/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import L from "./Lang";
import Globals from "../shared/Globals";
import Icon from "./Icon";
import Alert from "./Alert";

class FormDataModal extends BaseCom {
    async componentDidMount() {
        await this.load();
    }

    async componentDidUpdate(prevProps) {
        if (this.props.siteDomainID !== prevProps.siteDomainID || this.props.col !== prevProps.col) {
            await this.load();
        }
    }

    load = async () => {
        if (!this.props.col?.id) return;
        await this.fillListAsync('/api/form/data?siteDomainID=' + this.props.siteDomainID + '&colID=' + this.props.col?.id, 'list');
    }

    showData = (item) => {
        let data = null;
        try {
            data = JSON.parse(item.jsonData);
        }
        catch(e) {
            console.error('Invalid JSON data.');
            return <Alert type="danger">Invalid data.</Alert>;
        }
        let arr = [];
        for (var k in data) {
            arr.push({
                name: k,
                value: data[k]
            });
        }
        return (
            <table className="table table-bordered">
                <tbody>
                    {arr.map((i, idx) => <tr key={idx}>
                        <td><strong>{i.name}</strong></td>
                        <td>{i.value}</td>
                    </tr>)}
                </tbody>
            </table>
        );
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onHide} size="lg">
                <Modal.Header closeButton>
                    <L>Data</L>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        {this.state.currentItem ? <div>
                            <div className="mb-3">
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ currentItem: null })}>
                                    <Icon icon="faArrowLeft" /> <L>Go Back</L>
                                </button>
                            </div>
                            {this.showData(this.state.currentItem)}
                        </div>
                            : this.state.list?.length === 0 ? <Alert>No data in form.</Alert>
                            :<DataTable
                                columns={[
                                    {
                                        name: 'createdDate', title: 'Created Date',
                                        valueFunc: row => (
                                            <div role="button" onClick={() => {
                                                this.setState({ currentItem: row })
                                            }}>
                                                {Globals.toMDYHMLocalDateString(row.createdDate)}
                                            </div>
                                        )
                                    }
                                ]}
                                data={this.state.list || []}
                            />}
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default withParamsAndNavigate(FormDataModal);